import { apiSlice } from './apiSlice';

export const welfareCheckAdminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // The Welfare Check settings of every Operator the signed-in user is
    // Admin for (every Operator, for a Platform Admin).
    getOperatorWelfareCheckSettings: builder.query({
      query: () => ({
        url: '/welfare-check-settings/operators/',
        method: 'GET',
      }),
      providesTags: ['WelfareCheckSettings'],
    }),
    updateOperatorWelfareCheckSettings: builder.mutation({
      query: ({ operatorId, ...settings }) => ({
        url: `/welfare-check-settings/operators/${operatorId}/`,
        method: 'PUT',
        body: settings,
      }),
      invalidatesTags: ['WelfareCheckSettings'],
    }),
    triggerWelfareCheckPoll: builder.mutation({
      query: () => ({
        url: '/welfare-check-monitor/run/',
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useGetOperatorWelfareCheckSettingsQuery,
  useUpdateOperatorWelfareCheckSettingsMutation,
  useTriggerWelfareCheckPollMutation,
} = welfareCheckAdminApiSlice;
